/**
 * axios的封装
 */
import axios from "axios";
import config from "./config";
// 正则替换图片host
let replaceImgUrl;
let baseURL = "/api";
let imageUrl =""
if (process.env.NODE_ENV === "development") {
  baseURL = "/api";
  replaceImgUrl = string => string;
} else {
  // baseURL = "http://47.95.238.93:8114/";
 replaceImgUrl = string => {
    const regex = /http:\/\/127.0.0.1:8114/g;
    return string.replace(regex, location.origin+"/api");
  };
}
axios.defaults.baseURL = baseURL;
axios.defaults.timeout = 10000;

axios.interceptors.request.use(
  config => {
    if (config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    }
    if (config.data) {
      console.log(config.data);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  res => {
    let json;
    try {
      json = replaceImgUrl(JSON.stringify(res.data));
      json = JSON.parse(json);
    } catch (error) {
      console.error(error);
    }
    return Promise.resolve(json);
  },
  error => {
    return Promise.reject(error);
  }
);

const apiFormat = (str, res) => {
  let reg = /\{(\w+?)\}/gi;
  return str.replace(reg, ($0, $1) => {
    return res[$1];
  });
};

export { axios, apiFormat, replaceImgUrl };
